import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {concatMap, map, tap} from 'rxjs/operators';
import {StatusService} from 'src/app/shared/services/status/status.service';
import { ResponsiveService } from 'src/app/shared/services/responsive/responsive.service';
import {ROUTESURL} from 'src/app/app-routing.model';
import {TRANSLATE_PATH as TRANSLATE_PATH_SHARED} from 'src/app/shared/shared.model'
import {TRANSLATE_PATH as TRANSLATE_PATH_PROJECT} from '../../project.model'
import {ForwardService} from '../../services/forward/forward.service';
import {TranslateDesignPipe} from 'src/app/shared/pipes/translate-design/translate-design.pipe';

@Component({
   selector: 'app-success-dialog',
   templateUrl: './success-dialog.component.html',
   standalone: false
})
export class SuccessDialogComponent implements OnInit, OnDestroy {
   
   public pTranslateDesign: TranslateDesignPipe = inject(TranslateDesignPipe);

   public TRANSLATE_PATH_SHARED = TRANSLATE_PATH_SHARED;
   public TRANSLATE_PATH_PROJECT = TRANSLATE_PATH_PROJECT;

   private forwardURL_: string = "";
   private showButton_: boolean = false;

   public get forwardURL (): string {
      return this.forwardURL_ ;
   }
   
   public get showButton (): boolean {
      return this.showButton_ ;
   }


   constructor (public sResponsive: ResponsiveService, private sForward: ForwardService, public dialogRef: MatDialogRef<SuccessDialogComponent>, private router: Router, public sStatus: StatusService) {
   }

   ngOnDestroy (): void {
      this.reset();
      this.sStatus.reset();
      this.sForward.reset();
   }

   ngOnInit (): void {
      this.forwardURL_ = this.pTranslateDesign.transform(this.sForward.afterLogin ? TRANSLATE_PATH_PROJECT.FORWARD_DIALOG_URL : TRANSLATE_PATH_PROJECT.SUCCESS_DIALOG_URL);
      this.showButton_ = this.pTranslateDesign.transform(this.sForward.afterLogin ? TRANSLATE_PATH_PROJECT.FORWARD_DIALOG_SHOWBUTTON : TRANSLATE_PATH_PROJECT.SUCCESS_DIALOG_SHOWBUTTON) == "true" ? true : false; 
   }

   public onExitButton (): void {
      this.reset();
      this.forwardURL_ ? this.sForward.afterLogin ? this.reloadCurrentRoute() : this.router.navigate([this.forwardURL_]) : '';
   }

   private reloadCurrentRoute (): void {
      this.router.navigateByUrl(ROUTESURL.SUCCESS, {skipLocationChange: true}).then(() => {
         this.router.navigate([this.forwardURL_]);
      });
   }

   private reset (): void {
      sessionStorage.clear();
   }
}
